import axios from "axios";
import { PROFESSIONALS_INTERACTION_URL } from "../../../utils";

export const fetchProfessionalsInteraction = async () => {
  return await axios.get(PROFESSIONALS_INTERACTION_URL);
};
